import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  wrapper: {},
  item: {
    display: 'flex',
    margin: '0 0 18px',
    padding: '0 0 18px',
    position: 'relative',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  photo: {
    minWidth: '120px',
    height: '120px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: '3px',
    backgroundColor: '#E2F5F8',
    margin: '0 20px 0 0',
    ['@media (max-width:600px)']: {
      minWidth: '80px',
      height: '80px'
    }
  },
  info: {
    width: '100%'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px'
  },
  button: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'normal',
    margin: '0 0 0 30px',
    color: '#949494'
  },
  icon: {
    fontSize: '12px',
    margin: '0 0 0 5px'
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  overview: {
    marginRight: '15px'
  },
  selected: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(7, 27, 39, .65)'
  },
  selectedIcon: {
    fontSize: '50px',
    color: 'white',
    ['@media (max-width:600px)']: {
      fontSize: '30px'
    }
  },
  divider: {
    display: 'block',
    height: '1px',
    width: 'calc(100% - 140px)',
    background: '#E2EBF6',
    position: 'absolute',
    bottom: 0
  },
  prices: {
    marginBottom: '5px',
    fontWeight: 'bold'
  }
});

export default useStyles;
